import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg
        id="free-swatch-add-to-cart-customization"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.58887 13.5526V7.55261H0.588867V6.55261H6.58887V0.552612H7.58887V6.55261H13.5889V7.55261H7.58887V13.5526H6.58887Z"
          fill="#877445"
        />
      </svg>
      ;
    </Icons>
  );
}
